import React, { useState } from "react";
import Button from "../components/Button";
import UserImageEditModal from "../components/UserImageEditModal";

export default function ChangeUserImage() {
  const [openEditModal, setOpenEditModal] = useState(false);
  return (
    <>
      <Button
        onClick={() => {
          setOpenEditModal(true);
        }}
      >
        Change User Image
      </Button>
      {openEditModal && (
        <UserImageEditModal
          onClosed={() => {
            setOpenEditModal(false);
          }}
        />
      )}
    </>
  );
}
